import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttachTrailerConfirmation = _resolveComponent("AttachTrailerConfirmation")!
  const _component_CrossCompanyConfirmation = _resolveComponent("CrossCompanyConfirmation")!

  return (_ctx.trailerIsAvailable && !_ctx.companyMismatch)
    ? (_openBlock(), _createBlock(_component_AttachTrailerConfirmation, {
        key: 0,
        trailerCompany: _ctx.trailerCompany,
        trailerNumber: _ctx.trailerNumber,
        onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onAccept'))),
        onReject: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onReject')))
      }, null, 8, ["trailerCompany", "trailerNumber"]))
    : (_ctx.companyMismatch)
      ? (_openBlock(), _createBlock(_component_CrossCompanyConfirmation, {
          key: 1,
          driverCompany: _ctx.driverCompany,
          trailerCompany: _ctx.trailerCompany,
          trailerNumber: _ctx.trailerNumber,
          onOnBackToScan: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onBackToScan')))
        }, null, 8, ["driverCompany", "trailerCompany", "trailerNumber"]))
      : _createCommentVNode("", true)
}